import * as React from 'react';

import moment from 'moment';

import {Select} from 'shells/select/select';

type Props = {
    includeThisMonth?: boolean;
    numMonths: number;
    selectedMonth: number;
    setSelectedMonth: (arg1: {id: number; label: string}) => void;
};

export const MonthPicker = (props: Props) => {
    const {includeThisMonth, numMonths, selectedMonth, setSelectedMonth} = props;

    const firstOption = includeThisMonth
        ? {id: 0, label: 'This month'}
        : {id: 1, label: 'Last month'};

    const options = [firstOption];

    for (let monthsAgo = includeThisMonth ? 1 : 2; monthsAgo <= numMonths; monthsAgo++) {
        const month = moment().subtract(monthsAgo, 'month').startOf('month').format('MMMM YYYY');

        options.push({id: monthsAgo, label: month});
    }

    return (
        <Select
            // @ts-expect-error
            size='large'
            value={options.find((opt) => opt.id === selectedMonth)}
            labelKey='label'
            selectValues={options}
            styleOptions={{filled: true, color: 'blue'}}
            onChange={setSelectedMonth}
        />
    );
};
